import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  OnChanges,
  SimpleChange,
  SimpleChanges,
  OnDestroy,
  NgZone,
} from '@angular/core';
import * as moment from 'moment';
import { FormGroup, FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { environment } from '../../../environments/environment';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AppStateService } from '../../services/appState/app-state.service';
import { Observable, Subscription } from 'rxjs';
import { debounceTime, last, map, shareReplay, takeLast } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'glm-select-date',
  templateUrl: './select-date.component.html',
  styleUrls: ['./select-date.component.css'],
})
export class SelectDateComponent implements OnInit, OnChanges, OnDestroy {
  @ViewChild('picker') matdatepicker: MatDatepicker<any>;

  @Output() dateChange = new EventEmitter();
  messageSubscription: Subscription;

  rangeStart = new FormControl();
  rangeEnd = new FormControl();

  range = new FormGroup({
    start: this.rangeStart,
    end: this.rangeEnd,
  });

  filterDateOptionsDay = [
    { label: 'Yesterday', value: '1', duration: 'day' },
    {
      label: 'Last 7 days',
      value: '7',
      duration: 'day',
      start: moment().subtract(7, 'd'),
      end: moment(),
    },
    {
      label: 'Last full week',
      value: '1-7',
      duration: 'day',
      start: moment().subtract(7, 'd').startOf('week'),
      end: moment(),
    },
    {
      label: 'Week to date',
      value: 'w_t_d',
      duration: 'day',
      start: moment().startOf('week'),
      end: moment(),
    },
  ];

  filterDateOptionsMonth = [
    {
      label: 'Last 30 Days',
      value: '30',
      duration: 'month',
      start: moment().subtract(30, 'd'),
      end: moment(),
    },
    {
      label: 'Last full Month',
      value: '1-30',
      duration: 'month',
      start: moment().subtract(1, 'M').startOf('month'),
      end: moment().subtract(1, 'M').endOf('month'),
    },
    {
      label: 'Month to date',
      value: 'm_t_d',
      duration: 'month',
      start: moment().startOf('month'),
      end: moment(),
    },
  ];

  filterDateOptionsQuarter = [
    {
      label: 'Last full Quarter',
      value: 'last_full',
      duration: 'quarter',
      start: moment().subtract(1, 'Q').startOf('quarter'),
      end: moment().subtract(1, 'Q').endOf('quarter'),
    },
    {
      label: 'Quarter to date',
      value: 'q_t_d',
      duration: 'quarter',
      start: moment().startOf('quarter'),
      end: moment(),
    },
  ];

  filterDateOptionsYear = [
    {
      label: 'Last full year',
      value: 'last_full',
      duration: 'year',
      start: moment().subtract(1, 'y').startOf('year'),
      end: moment().subtract(1, 'y').endOf('years'),
    },
    {
      label: 'Year to Date',
      value: 'y_t_d',
      duration: 'year',
      start: moment().startOf('year'),
      end: moment(),
    },
  ];

  title = 'Past 30 days';
  labelLast30Days = 'May 21 - June 21';
  value = 'May 21 - Jun 21';
  currentCriteria = 'last_30';

  startDate = new Date().toISOString();

  startDateObject;
  endDateObject;

  startDateLabel;
  endDateLabel;

  startShowDateLabel;
  endShowDateLabel;

  modelStart;
  modelEnd;

  dashboardName = '';

  graphDurationType = 'daily';
  isFirstInit = false;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result) => result.matches),
      shareReplay(),
    );

  constructor(
    private router: Router,
    private activatedRouter: ActivatedRoute,
    private location: Location,
    private serviceAppState: AppStateService,
    private ngZone: NgZone,
    private breakpointObserver: BreakpointObserver,
  ) {
    this.isFirstInit = false;
  }

  ngOnInit(): void {
    this.router.events.subscribe((param) => {
      if (param instanceof NavigationEnd) {
        this.getDatesByConfig();
        this.emitData();
      }
    });
    this.dashboardName = environment.client_env;
    this.getDatesByConfig();
    this.emitData();

    this.range.valueChanges.pipe(debounceTime(1000)).subscribe((param) => {
      if (this.isQuarterly) {
        let oneDay;
        this.matdatepicker.close();
        if (param.start) {
          oneDay = param.start;
        }
        if (param.end) {
          oneDay = param.end;
        }
        this.dateValueChange('from', { value: oneDay });
        this.dateValueChange('to', { value: oneDay });
      } else {
        if (param.start && param.end) {
          this.dateValueChange('from', { value: param.start });
          this.dateValueChange('to', { value: param.end });
        }
      }
    });

    this.messageSubscription =
      this.serviceAppState.graphDurationMessage.subscribe((message) => {
        this.graphDurationType = message.type;
        this.ngZone.run(() => {
          this.isQuarterly =
            this.graphDurationType == 'quarterly' ? true : false;
          if (this.isQuarterly) {
            let oneDay = new Date().toISOString();

            this.dateValueChange('from', { value: oneDay });
            this.dateValueChange('to', { value: oneDay });
          } else {
            this.emitData();
          }
        });
      });
  }

  isQuarterly = false;

  ngOnDestroy() {
    this.messageSubscription ? this.messageSubscription.unsubscribe() : false;
  }
  openPopUp() {
    this.matdatepicker.open();
  }
  ngOnChanges(s: SimpleChanges) {}

  getDatesByConfig() {
    if (this.dashboardName == 'covid') {
      this.getLastNDays(3);
      this.isFirstInit = true;
    } else if (this.location.path() == '/heatmaps') {
      this.getLastNDays(2);
      this.endDateObject.setDate(this.endDateObject.getDate() - 1);
      this.endDateLabel = moment(this.endDateObject)
        .format('YYYY-MM-DD HH:mm:ss')
        .toString();
      this.endShowDateLabel = moment(this.endDateObject).format('MMM DD, YYYY');
      this.labelLast30Days = `${this.startShowDateLabel} - ${this.endShowDateLabel}`;
      this.isFirstInit = false;
    } else if (!this.isFirstInit) {
      this.getLastNDays(3);
      this.isFirstInit = true;
    }
    this.isQuarterly = false;
  }

  changeFiltervalue(criteria) {
    this.title = criteria.label;
    let dayFormat = 'MMM DD, YY';
    let yearFormat = 'MMM DD';

    if (this.dashboardName == 'covid') {
      return false;
    }
    if (criteria.duration == 'day') {
      if (criteria.value == '1') {
        this.getYesterDay(criteria.start, criteria.end, dayFormat);
      } else {
        this.getCustomDates(criteria.start, criteria.end, dayFormat);
      }
    } else {
      this.getCustomDates(criteria.start, criteria.end, yearFormat);
    }
  }

  dateValueChange(time, event) {
    try {
      //
      if (time == 'from') {
        this.modelStart = event.value;
      } else if (time == 'to') {
        this.modelEnd = event.value;
      }
      //
      if (this.modelStart && this.modelEnd) {
        this.getCustomDates(this.modelStart, this.modelEnd, 'MMM DD, YY');
      }
    } catch (err) {
      console.error(err);
    }
  }

  getPastThirtyDays() {
    this.endDateObject = new Date();
    this.startDateObject = new Date();
    this.startDateObject.setDate(this.startDateObject.getDate() - 7);
    this.startDateLabel = moment(this.startDateObject)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.startShowDateLabel = moment(this.startDateObject).format(
      'MMM DD, YYYY',
    );

    this.endDateLabel = moment(this.endDateObject)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.endShowDateLabel = moment(this.endDateObject).format('MMM DD, YYYY');
    this.labelLast30Days = `${this.startShowDateLabel} - ${this.endShowDateLabel}`;
    //
  }
  getLastNDays(interval) {
    this.endDateObject = new Date();
    this.startDateObject = new Date();
    this.startDateObject.setDate(
      this.startDateObject.getDate() - (interval - 1),
    );
    this.startDateLabel = moment(this.startDateObject)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.startShowDateLabel = moment(this.startDateObject).format(
      'MMM DD, YYYY',
    );

    this.endDateLabel = moment(this.endDateObject)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.endShowDateLabel = moment(this.endDateObject).format('MMM DD, YYYY');
    this.labelLast30Days = `${this.startShowDateLabel} - ${this.endShowDateLabel}`;
  }
  covidHardcodedDates() {
    this.endDateObject = new Date('2020-10-06');
    this.startDateObject = new Date('2020-09-28');

    this.startDateObject.setDate(this.startDateObject.getDate());
    this.startDateLabel = moment(this.startDateObject)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.startShowDateLabel = moment(this.startDateObject).format(
      'MMM DD, YYYY',
    );

    this.endDateLabel = moment(this.endDateObject)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.endShowDateLabel = moment(this.endDateObject).format('MMM DD, YYYY');
    this.labelLast30Days = `${this.startShowDateLabel} - ${this.endShowDateLabel}`;
  }

  getCustomDates(start, end, showLabel) {
    let startMoment = moment(start);
    let endMoment = moment(end);
    if (startMoment.isAfter(endMoment)) {
      end = start;
    }

    this.startDateLabel = moment(start)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.startShowDateLabel = moment(start).format(showLabel);

    this.endDateLabel = moment(end).format('YYYY-MM-DD HH:mm:ss').toString();
    this.endShowDateLabel = moment(end).format(showLabel);

    this.labelLast30Days = `${this.startShowDateLabel} - ${this.endShowDateLabel}`;
    this.emitData();
  }

  getCustomDatesLabel(criteria) {
    let dayFormat = 'MMM DD, YY';
    let yearFormat = 'MMM DD';
    let showLabel = yearFormat;
    this.title = criteria.label;
    if (criteria.duration == 'day') {
      showLabel = dayFormat;
      if (criteria.value == '1') {
      } else {
        showLabel = yearFormat;
      }
    } else {
      showLabel = yearFormat;
    }

    let label;
    this.startShowDateLabel = moment(criteria.start).format(showLabel);
    this.endShowDateLabel = moment(criteria.end).format(showLabel);
    label = `${this.startShowDateLabel} - ${this.endShowDateLabel}`;

    this.startDateLabel = moment(this.startDateLabel)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.endDateLabel = moment(this.endDateLabel)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();

    return label;
  }
  getYesterDay(start, end, showLabel) {
    this.startDateLabel = moment(start)
      .format('YYYY-MM-DD HH:mm:ss')
      .toString();
    this.startShowDateLabel = moment(start).format(showLabel);

    this.endDateLabel = moment(end).format('YYYY-MM-DD HH:mm:ss').toString();
    this.endShowDateLabel = moment(end).format(showLabel);

    this.labelLast30Days = `${this.endShowDateLabel}`;
    this.emitData();
  }

  setCustomDates() {
    this.getCustomDates(this.modelStart, this.modelEnd, 'MMM DD, YY');
    this.emitData();
  }

  emitData() {
    let data = {};
    data['start_date'] = this.startDateLabel;
    data['end_date'] = this.endDateLabel;
    let startMoment = moment(this.startDateLabel);
    let endMoment = moment(this.endDateLabel);
    if (startMoment.isAfter(endMoment)) {
      data['end_date'] = this.startDateLabel;
    }
    localStorage.setItem('rangeStartDate', data['start_date']);
    localStorage.setItem('rangeEndDate', data['end_date']);

    this.dateChange.emit(data);
  }
}
